/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { DatasetPostSchema } from './admin-dataset.post';

const Params = z.strictObject({ id: ZodTypes.Id });
export const AdminDatasetPatch = {
  id: 'admin-dataset.patch',
  tag: 'Admin',
  summary: 'Admin Update Dataset',
  description: 'Update dataset',
  method: 'patch',
  flags: { isAuthorized: true, isSuperuser: true },
  route: (params: z.infer<typeof Params>) => `/administration/dataset/${params.id}`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: DatasetPostSchema,
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
